import { BreadcrumbTestIdFactory } from '../../Breadcrumb/interactions';
import { TableTestIdFactory } from '../../Table/interactions';
export const ListFileBrowserTestIdFactory = {
    // bases
    getListFileBrowserBase: () => 'list-file-browser',
    getListFileBrowserBreadcrumbErrorBase: () => 'list-file-browser-breadcrumb-error',
    getListFileBrowserEmptyBase: () => 'list-file-browser-empty',
    getListFileBrowserErrorBase: () => 'list-file-browser-error',
    getListFileBrowserFiltersBase: () => 'list-file-browser-filters',
    getListFileBrowserHeaderActionBase: () => 'list-file-browser-header-action',
    getListFileBrowserSearchBase: () => 'list-file-browser-search',
    getListFileBrowserSearchResultsBase: () => 'list-file-browser-search-results',
    // for test id generation
    getListFileBrowserBaseTestId: (testId) => [ListFileBrowserTestIdFactory.getListFileBrowserBase(), testId].join('-'),
    getListFileBrowserBreadcrumbTestId: (testId) => BreadcrumbTestIdFactory.getBreadcrumbTestId(ListFileBrowserTestIdFactory.getListFileBrowserBaseTestId(testId)),
    getListFileBrowserBreadcrumbErrorTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserBreadcrumbErrorBase(),
        testId,
    ].join('-'),
    getListFileBrowserBreadcrumbLoadingTestId: (testId) => BreadcrumbTestIdFactory.getBreadcrumbLoadingTestId(ListFileBrowserTestIdFactory.getListFileBrowserBaseTestId(testId)),
    getListFileBrowserLoadingTestId: (testId) => TableTestIdFactory.getTableLoadingTestId(ListFileBrowserTestIdFactory.getListFileBrowserBaseTestId(testId)),
    getListFileBrowserTableTestId: (testId) => TableTestIdFactory.getTableRootTestId(ListFileBrowserTestIdFactory.getListFileBrowserBaseTestId(testId)),
    getListFileBrowserTableRowTestId: (entryId, testId) => TableTestIdFactory.getTableRowTestId(entryId, ListFileBrowserTestIdFactory.getListFileBrowserBaseTestId(testId)),
    getListFileBrowserEmptyTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserEmptyBase(),
        testId,
    ].join('-'),
    getListFileBrowserErrorTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserErrorBase(),
        testId,
    ].join('-'),
    getListFileBrowserFiltersTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserFiltersBase(),
        testId,
    ].join('-'),
    getListFileBrowserHeaderActionTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserHeaderActionBase(),
        testId,
    ].join('-'),
    getListFileBrowserSearchTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserSearchBase(),
        testId,
    ].join('-'),
    getListFileBrowserSearchResultsTestId: (testId) => [
        ListFileBrowserTestIdFactory.getListFileBrowserSearchResultsBase(),
        testId,
    ].join('-'),
};
